import { Icons, Text, defaultTheme } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { refetchFunc, useSingleEntity } from 'modules/domain/common/hooks'
import { Deal, DealContract } from 'modules/domain/deal/types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { generatePath } from 'react-router-dom'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { ContractsRoutes } from 'views/pages/Contracts/routes'
import { MultiCardContainerStyled, RouterLinkStyled, Title } from '../styled'
import { ContractRequestModal } from './ContractRequestModal/ContractRequestModal'
import { EditContractRequestModal } from './ContractRequestModal/EditContractRequestModal'
import { MobileContractRequest } from './MobileContractRequest'
import { RemoveContract } from './RemoveContract'
import { TagsStatus } from './TagsStatus'
import { endpoints } from 'modules/endpoints'

const ButtonsWrapper = styled.div`
  display: flex;
  column-gap: 4px;
`

const ControlsWrapper = styled.div`
  display: flex;
  column-gap: 16px;
`

type Props = {
  refetch: refetchFunc
  deal: Deal
}

export const ContractRequest = ({ deal, refetch }: Props) => {
  const { t } = useTranslation('deal')
  const [requestDocsModal, setRequestDocsModal] = useState(false)
  const [editDocsModal, setEditDocsModal] = useState(false)
  const [contractProgress, detailedContract] = useSingleEntity<DealContract>(
    editDocsModal ? endpoints.dealsContracts(deal.sale_contract_request.id) : undefined,
  )

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  return (
    <>
      {isMobile ? (
        <MobileContractRequest
          openRequestDocsModal={() => setRequestDocsModal(true)}
          openEditDocsModal={() => setEditDocsModal(true)}
          refetch={refetch}
          deal={deal}
        />
      ) : (
        <MultiCardContainerStyled enableHover={!!deal?.sale_contract_request} intent="primary" bordered>
          {deal?.sale_contract_request?.id && (
            <RouterLinkStyled
              eventName="contract"
              to={generatePath(ContractsRoutes.Details, { id: deal.sale_contract_request.id })}
            />
          )}
          <div>
            <Title>{t('requestContractBlock.title')}</Title>
            {deal.sale_contract_request && (
              <Text typography="bodyMedium" color="secondary">
                {t('requestContractBlock.assignee')}: {deal.sale_contract_request.assignee?.full_name ?? DASH}
              </Text>
            )}
          </div>
          {deal.sale_contract_request ? (
            <ControlsWrapper>
              <TagsStatus contract={deal.sale_contract_request} />
              <ButtonsWrapper>
                <AButton
                  id="edit_request_docs"
                  color="secondary"
                  background="none"
                  Icon={Icons.IconEdit}
                  progress={contractProgress}
                  onClick={() => setEditDocsModal(true)}
                />

                <RemoveContract contractId={deal.sale_contract_request.id} onSuccess={refetch} />
              </ButtonsWrapper>
            </ControlsWrapper>
          ) : (
            <AButton id="request_docs" color="primary" onClick={() => setRequestDocsModal(true)}>
              {t('requestContractBlock.request_docs')}
            </AButton>
          )}
        </MultiCardContainerStyled>
      )}
      {requestDocsModal && (
        <ContractRequestModal deal={deal} onSuccess={refetch} onClose={() => setRequestDocsModal(false)} />
      )}
      {editDocsModal && detailedContract && (
        <EditContractRequestModal
          deal={deal}
          contract={detailedContract}
          onSuccess={refetch}
          onClose={() => setEditDocsModal(false)}
        />
      )}
    </>
  )
}
